import {Item, Root} from '@radix-ui/react-toggle-group'
import styled, {css} from 'styled-components'

export const StyledToggleGroupRoot = styled(Root)(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        background-color: ${palette.neutral['100']};
        border: 1px solid ${palette.neutral['200']};
        border-radius: 20px;
        overflow: hidden;
        width: 100%;
    `
)

export const StyledToggleGroupItem = styled(Item)(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textSm};
        padding: ${spacing}px ${spacing * 5}px;
        text-align: center;
        cursor: pointer;
        color: ${palette.neutral['600']};
        font-weight: 500;

        &[data-state='on'] {
            outline: 1px solid ${palette.neutral['200']};
            background-color: ${palette.neutral.white};
            border-radius: 20px;
            color: ${palette.neutral['950']};
        }
    `
)
